require("core-js/modules/es6.object.define-property");

/* THIS IS A BIT-AUTO-GENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
Object.defineProperty(exports, "__esModule", {
  value: true
});
module.exports = require('@bit/dweez.perso.quizz.contexts/dist/utils');